import { Container, Spinner } from "react-bootstrap";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import { usePage } from "../../hooks/usePage";
import { usePrecargaEvents } from "../../hooks/usePrecargaEvents";
import { usePrecargaParticipants } from "../../hooks/usePrecargaParticipants";
import useSearchParamState from "../../hooks/useSearchParamState";
import ServerTable from "../../components/ServerTable/ServerTable";

export default function PrecargasParticipants() {
  usePage({ title: "Precargas - Participantes" });

  const { eventid } = useParams();
  const navigate = useNavigate();
  const cashlessEventId = eventid ? parseInt(eventid) : null;

  const { precargaEvent, isLoadingPrecargaEvent, hasPrecargaEvent } =
    usePrecargaEvents({
      cashlessEventId,
    });

  // Pagination and filters
  const [page, setPage] = useSearchParamState("page", 1);
  const [pageSize, setPageSize] = useSearchParamState("pageSize", 20);
  const [search, setSearch] = useSearchParamState("search", "");
  const [sortBy, setSortBy] = useSearchParamState("sortBy", "last_activity_at");
  const [sortDir, setSortDir] = useSearchParamState("sortDir", "desc");

  const { participants, totalCount, isLoading, isError } = usePrecargaParticipants({
    eventId: precargaEvent?.id,
    page: parseInt(page),
    pageSize: parseInt(pageSize),
    search,
    sortBy,
    sortDir,
  });

  if (isLoadingPrecargaEvent) {
    return (
      <Container fluid>
        <div className="text-center p-5">
          <Spinner animation="border" />
          <p className="mt-3">Cargando configuración de precarga...</p>
        </div>
      </Container>
    );
  }

  if (!eventid) {
    return null;
  }

  if (!hasPrecargaEvent) {
    return <Navigate to={`/${eventid}/preloads/create`} replace />;
  }

  const columns = [
    {
      label: "Email",
      key: "email",
      type: "string",
    },
    {
      label: "Total Órdenes",
      key: "total_orders",
      type: "number",
      width: 120,
    },
    {
      label: "Total Gastado",
      key: "total_spent",
      type: "currency",
      width: 140,
    },
    {
      label: "Saldo",
      key: "balance",
      type: "currency",
      width: 120,
    },
    {
      label: "Vinculaciones",
      key: "card_links_count",
      type: "number",
      width: 120,
    },
    {
      label: "Última Actividad",
      key: "last_activity_at",
      type: "date",
      width: 180,
    },
  ];

  return (
    <Container fluid>
      <h2>Participantes</h2>
      <p className="text-muted mb-4">
        Lista de usuarios participantes en el sistema de precargas
      </p>
      <ServerTable
        title="Participantes"
        data={participants}
        columns={columns}
        isLoading={isLoading}
        isError={isError}
        showExcel={true}
        showFilters={false}
        showPagination={true}
        page={parseInt(page, 10)}
        pageSize={parseInt(pageSize, 10)}
        totalCount={totalCount}
        sortBy={sortBy}
        sortDir={sortDir}
        onSortChange={({ sortBy: nextSortBy, sortDir: nextSortDir }) => {
          if (nextSortBy !== sortBy || nextSortDir !== sortDir) {
            setSortBy(nextSortBy);
            setSortDir(nextSortDir);
            setPage(1);
          }
        }}
        onPageChange={(nextPage) => {
          if (nextPage !== parseInt(page, 10)) setPage(nextPage);
        }}
        onPageSizeChange={(nextSize) => {
          if (nextSize !== parseInt(pageSize, 10)) {
            setPageSize(nextSize);
            setPage(1);
          }
        }}
        onSelectRow={(row) => navigate(`/${eventid}/preloads/participants/${row.userId}`)}
      />
    </Container>
  );
}
